<template>
  <h4 style="margin-top: 20px">
    <span style="color: blue">Government Application Breakdown</span>
  </h4>

  <div class="mainDiv">
    <div>
      <h1 class="mb-2 mt-2">Application Converage</h1>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h3 class="progress-title">HTML</h3>
          <div class="progress">
            <div class="progress-bar" style="width: 65%; background: #97c513">
              <div class="progress-value">65%</div>
            </div>
          </div>
          <h3 class="progress-title">CSS</h3>
          <div class="progress">
            <div class="progress-bar" style="width: 100%; background: #f2545b">
              <div class="progress-value">100%</div>
            </div>
          </div>
          <h3 class="progress-title">JAVASCRIPT</h3>
          <div class="progress">
            <div class="progress-bar" style="width: 75%; background: #4286f4">
              <div class="progress-value">75%</div>
            </div>
          </div>
          <h3 class="progress-title">BOOTSTRAP</h3>
          <div class="progress">
            <div class="progress-bar" style="width: 30%; background: #21ff63">
              <div class="progress-value">30%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.progress-title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin: 0 0 20px;
}

.progress {
  height: 20px;
  background: #333;
  border-radius: 0;
  box-shadow: none;
  margin-bottom: 30px;
  overflow: visible;
}

.progress .progress-bar {
  position: relative;
  -webkit-animation: animate-positive 2s;
  animation: animate-positive 2s;
}

.progress .progress-value {
  display: block;
  font-size: 18px;
  font-weight: 500;
  color: black;
  position: absolute;
  top: -30px;
  right: -25px;
}

.progress .progress-bar:after {
  content: "";
  display: inline-block;
  width: 10px;
  background: #fff;
  position: absolute;
  top: -10px;
  bottom: -10px;
  right: -5px;
  z-index: 1;
  transform: rotate(35deg);
}

h1 {
  text-align: center;
}

.mainDiv {
  background: linear-gradient(to right, #d9a7c7, #fffcdc);
}
</style>
